








import { listFactory } from '@/main/pages/listFactory';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	methods: {
		async filterClick() {
			this.$router.replace({ path: '/Oem/DealersCPFForm/List', query: { dealerTenantCode: this.dealers ?? '' } });
		},
	},
});
